<script setup lang="ts">
  import { Button, ScrollArea } from '@rapoo/element'
  import { AUDIO_RHYTHM_COLORS, type AudioRhythmColorId, type ColorStop } from '@rapoo/device-sdk'

  defineOptions({ name: 'ColorList' })

  /** 与 sdk-test / 引擎共用 AUDIO_RHYTHM_COLORS，保证顺序和色值一致。 */
  const colors = AUDIO_RHYTHM_COLORS.map((item) => ({
    ...item,
    i18nKey: `lighting.audioRhythmColor.${item.id}`,
  }))

  const modelValue = defineModel<AudioRhythmColorId>({ default: 'neonCyan' })

  const selectColor = (id: AudioRhythmColorId) => {
    modelValue.value = id
  }

  const LIGHT_DIRECTION_ICON = '#ahub-LightEffect-Fill-LightDirection'

  function stopColor({ r, g, b }: ColorStop['color']) {
    return `rgb(${r}, ${g}, ${b})`
  }
</script>

<template>
  <div class="glass-frosted w-88.5 rounded-8xl p-4 relative max-h-70 box-border">
    <div class="flex items-center justify-between">
      <div class="text-l-medium text-black-white">{{ $t('lighting.colorTitle') }}</div>
      <span class="text-s-medium text-text-glass-hover">{{ $t('lighting.referenceOnly') }}</span>
    </div>
    <ScrollArea class="overflow-x-hidden max-h-50 mt-3 h-full">
      <div class="grid grid-cols-3 gap-2">
        <Button
          v-for="item in colors"
          :key="item.id"
          color="normal"
          :active="modelValue === item.id"
          class="h-10 px-3"
          @click="selectColor(item.id)"
        >
          <svg class="shrink-0" viewBox="0 0 24 24" aria-hidden="true">
            <defs>
              <linearGradient :id="`audio-color-${item.id}`" x1="0" y1="0" x2="1" y2="0">
                <stop
                  v-for="(stop, stopIndex) in item.stops"
                  :key="stopIndex"
                  :offset="`${stop.t * 100}%`"
                  :stop-color="stopColor(stop.color)"
                />
              </linearGradient>
              <mask :id="`audio-color-mask-${item.id}`">
                <use
                  :href="LIGHT_DIRECTION_ICON"
                  :xlink:href="LIGHT_DIRECTION_ICON"
                  style="color: #fff"
                />
              </mask>
            </defs>
            <rect
              width="24"
              height="24"
              :fill="`url(#audio-color-${item.id})`"
              :mask="`url(#audio-color-mask-${item.id})`"
            />
          </svg>
          <span class="relative text-xs font-medium truncate min-w-12">
            {{ $t(item.i18nKey) }}
          </span>
        </Button>
      </div>
    </ScrollArea>
  </div>
</template>
